const Storage = {
  s: {
    set(key: string, val: any, isObject = true) {
      return isObject
        ? sessionStorage.setItem(key, JSON.stringify(val))
        : sessionStorage.setItem(key, val);
    },
    get(key: string, isReturnObject = true) {
      const val = sessionStorage.getItem(key);
      if (val) {
        try {
          return isReturnObject
            ? JSON.parse(val)
            : val;
        } catch (e) {
          return null;
        }
      } else {
        return null;
      }
    },
    remove(key: string) {
      if (!sessionStorage[key]) return false;
      sessionStorage.removeItem(key);
      return true;
    },
    clear() {
      sessionStorage.clear();
    },
  },
  l: {
    set(key: string, val: any, isObject = true) {
      return isObject
        ? localStorage.setItem(key, JSON.stringify(val))
        : localStorage.setItem(key, val);
    },
    get(key: string, isReturnObject = true) {
      const val = localStorage.getItem(key);
      if (val) {
        try {
          return isReturnObject
            ? JSON.parse(val)
            : val;
        } catch (e) {
          return null;
        }
      } else {
        return null;
      }
    },
    remove(key: string) {
      if (!localStorage[key]) return false;
      localStorage.removeItem(key);
      return true;
    },
    clear() {
      localStorage.clear();
    },
  },
};

export default Storage;
